import React from 'react';
import { View, ScrollView, StyleSheet } from 'react-native';
import BaseText from '../components/BaseText';
import { Color, CommonProperties, CommonStyles } from '../styles';
import { useTranslation } from 'react-i18next';
import { useComponentTKey, i18nNS } from '../i18n';

const PrivacyScreen = () => {
  const { t } = useTranslation(i18nNS.privacy);
  const { tKey } = useComponentTKey('PrivacyScreen');
  return (
    <ScrollView style={styles.scrollView}>
      <View style={styles.container}>
        <BaseText style={styles.heading}>{t(tKey('Privacy'))}</BaseText>
        <BaseText style={CommonStyles.mb3}>{t(tKey('Committed'))}</BaseText>
        <BaseText style={styles.subHeading}>{t(tKey('InformationCollected'))}</BaseText>
        <BaseText style={CommonStyles.mb3}>{t(tKey('NonPersonalInformation'))}</BaseText>
        <BaseText style={styles.subHeading}>{t(tKey('PersonalInformation'))}</BaseText>
        <BaseText style={CommonStyles.mb3}>{t(tKey('PersonalInformationContent'))}</BaseText>
        <BaseText style={styles.subHeading}>{t(tKey('UseofInformation'))}</BaseText>
        <BaseText style={CommonStyles.mb3}>{t(tKey('InformationYouProvide'))}</BaseText>
        <BaseText style={styles.subHeading}>{t(tKey('UseOfCookies'))}</BaseText>
        <BaseText style={CommonStyles.mb3}>{t(tKey('CookiesContent'))}</BaseText>
        <BaseText style={styles.subHeading}>{t(tKey('Security'))}</BaseText>
        <BaseText style={CommonStyles.mb3}>{t(tKey('SecurityMeasures'))}</BaseText>
        <BaseText style={styles.subHeading}>{t(tKey('StorageOfInfo'))}</BaseText>
        <BaseText style={CommonStyles.mb3}>{t(tKey('ReasonablePrecautions'))}</BaseText>
        <BaseText style={styles.subHeading}>{t(tKey('ExternalLinks'))}</BaseText>
        <BaseText style={CommonStyles.mb3}>{t(tKey('OtherLinks'))}</BaseText>
        <BaseText style={styles.subHeading}>{t(tKey('GlobalOrganization'))}</BaseText>
        <BaseText style={CommonStyles.mb3}>{t(tKey('GlobalOrganizationContent'))}</BaseText>
        <BaseText style={styles.subHeading}>{t(tKey('DisclosuresRequired'))}</BaseText>
        <BaseText style={CommonStyles.mb3}>{t(tKey('PursuantToJudicial'))}</BaseText>
        <BaseText style={styles.subHeading}>{t(tKey('MergersOrAcquisitions'))}</BaseText>
        <BaseText style={CommonStyles.mb3}>{t(tKey('ReorganizeBusinesses'))}</BaseText>
        <BaseText style={styles.subHeading}>{t(tKey('ChangesPrivacyPolicy'))}</BaseText>
        <BaseText style={CommonStyles.mb3}>{t(tKey('ChangesPrivacyPolicyContent'))}</BaseText>
        <BaseText style={styles.subHeading}>{t(tKey('ContactInformation'))}</BaseText>
        <BaseText style={CommonStyles.mb3}>{t(tKey('contactTripEasy'))}</BaseText>
        <BaseText style={CommonStyles.mb3}>{t(tKey('complaintsTripEasy'))}</BaseText>
        <BaseText style={CommonStyles.mb3}>{t(tKey('WebMaintainedByTripEasy'))}</BaseText>
      </View>
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
    backgroundColor: '#F4F4F4',
  },
  heading: {
    alignSelf: 'center',
    ...CommonProperties.h2,
  },
  subHeading: {
    fontWeight: 'bold',
    ...CommonProperties.h3,
    ...CommonProperties.mb3,
  },
  container: {
    backgroundColor: Color.accent,
    ...CommonProperties.m3,
    ...CommonProperties.p3,
  },
});

export default PrivacyScreen;
